import * as React from "react";

export const Overlay: React.StatelessComponent<{ message: string }> = (props) => {

    return <div
        style={{
            "position": "fixed",
            top: 0,
            left: 0,
            zIndex: 1090,
            width: "100%",
            height: "100%"
        }}>
        <div style={{
            width: "100%",
            height: "100%",
            backgroundColor: "gray",
            zIndex: 1090,
            opacity: 0.25,
        }}>

        </div>
        <div style={{
            position: "absolute",
            width: "100%",
            marginTop: "-10px",
            zIndex: 1091,
            "opacity": 1,
            "color": "black",
            "top": "50%",
            "fontSize": "30px",
            "textAlign": "center"
        }}>
            <span style={{
                padding: "30px 100px",
                border: "1px solid lightgray",
                backgroundColor: "white",
                borderRadius: "5px"
            }}>
                {props.message || "Загрузка..."}
            </span>
        </div>
    </div>;
};


